import { useEffect, useMemo } from 'react';

import {
  ROUTE_TYPE_TYPE,
  useRouter,
  useServiceAppState,
  useServiceMetaQuery,
} from '@kc-console/context';
import { matchPath } from '@kc-console/core';

import normalizeRedirectPath from '../../utils/normalizeRedirectPath';

const useServiceRedirectEffect = () => {
  const router = useRouter();
  const {
    state: { serviceKeyword },
  } = useServiceAppState();
  const { data: serviceMeta, isError: isErrorServiceMeta } = useServiceMetaQuery();
  const { routes = [] } = serviceMeta || {};
  const routePath = useMemo(() => {
    const pathname = router.asPath.split('?')[0];
    return pathname.replace(`${serviceKeyword}/`, '');
  }, [router.asPath, serviceKeyword]);

  useEffect(() => {
    if (isErrorServiceMeta) return;
    const matchedRoute = routes?.find(route => matchPath(routePath, route.path));

    if (matchedRoute?.routeType === ROUTE_TYPE_TYPE.REDIRECT) {
      router.replace(normalizeRedirectPath({ routePath, matchedRoute, serviceKeyword }));
    }
  }, [isErrorServiceMeta, routes, routePath, router, serviceKeyword]);
};

export default useServiceRedirectEffect;
